// import React, { useEffect, useRef, useState } from "react";
// import "./people.scss";
// import AddNewUser from "./editUser";
// import BulkUpload from "./BulkUpload/BulkUpload";
// import UploadSummaryModal from "./BulkUpload/UploadSummaryModal";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   addNewUser,
//   analyticsReport,
//   changeRole,
//   deActivateUser,
//   getCSVUploadedData,
//   reActivateUser,
// } from "../../Redux/Admin_Panel/people/people.action";
// import { REACTIVATE_USER } from "../../utils/api";
// import { useNavigate } from "react-router-dom";
// import AddSingleUser from "./addSingleUser";
// import * as XLSX from "xlsx";
// import ToastMessage from "../../utils/toasts/toastMessage";

// const FILTER_OPTIONS = [
//   // "id",
//   "class",
//   "division",
//   "first name",
//   "last name",
// ];

// export default function PeopleBodyPage() {
//   const dispatch = useDispatch();
//   const nav = useNavigate();

//   const store = useSelector((state) => state);
//   const csvDataStore = useSelector(
//     (state) => state?.AdminPeopleManager?.csvData,
//   );

//   const [openFilter, setOpenFilter] = useState(false);
//   const [userData, setUserData] = useState(null);
//   const [userData1, setUserData1] = useState(null);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [openMenuId, setOpenMenuId] = useState(null);
//   const [showAddUser, setShowAddUser] = useState(false);
//   const [showBulkUpload, setShowBulkUpload] = useState(false);
//   const [showAddSingleUserModal, setShowAddSingleUserModal] = useState(false);
//   const [lastUploadData, setLastUploadData] = useState(null);
//   const [showUploadSummary, setShowUploadSummary] = useState(false);

//   const [nameSort, setNameSort] = useState("");
//   const [idSort, setIdSort] = useState(null);

//   const [toastState, setToastState] = useState({
//     show: false,
//     message: "",
//     type: "",
//   });
//   const [roleFilter, setRoleFilter] = useState("all");

//   const [selectedUsers, setSelectedUsers] = useState(new Set());

//   // New State to track the user being edited
//   const [inputValues, setInputValues] = useState({});
//   const [userToEdit, setUserToEdit] = useState(null);
//   const [activeFilters, setActiveFilters] = useState({});

//   const [roleId, setRoleId] = useState(0);

//   const dropdownRef = useRef(null);
//   const menuRef = useRef({});
//   const userData1Ref = useRef(null);
//   const activeFiltersRef = useRef({});

//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   //  Keep ref in sync with state
//   useEffect(() => {
//     userData1Ref.current = userData1;
//   }, [userData1]);

//   // Keep ref in sync with state (near your other useEffects)
//   useEffect(() => {
//     activeFiltersRef.current = activeFilters;
//   }, [activeFilters]);

//   useEffect(() => {
//     if (csvDataStore?.users?.length > 0) {
//       const reversed = [...csvDataStore.users].reverse();
//       setUserData(reversed);
//       setUserData1(reversed);
//     } else {
//     }
//   }, [csvDataStore]);

//   useEffect(() => {
//     dispatch(getCSVUploadedData());
//   }, [dispatch]);

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (
//         openMenuId !== null &&
//         menuRef.current[openMenuId] &&
//         !menuRef.current[openMenuId].contains(e.target)
//       ) {
//         setOpenMenuId(null);
//       }

//       if (
//         openFilter &&
//         dropdownRef.current &&
//         !dropdownRef.current.contains(e.target)
//       ) {
//         setOpenFilter(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [openMenuId, openFilter]);

//   //-------------------------------------------- user sorting --------------------------------------------

//   // const sortedData = React.useMemo(() => {
//   //   let users = Array.isArray(userData) ? [...userData] : [];
//   //   if (nameSort === "asc") {
//   //     users.sort((a, b) =>
//   //       (a?.firstname || "").localeCompare(b?.firstname || ""),
//   //     );
//   //   } else if (nameSort === "desc") {
//   //     users.sort((a, b) =>
//   //       (b?.firstname || "").localeCompare(a?.firstname || ""),
//   //     );
//   //   } else if (idSort === "asc") {
//   //     users.sort(
//   //       (a, b) =>
//   //         parseInt(String(a?.user_id).match(/\d+/)?.[0] || 0) -
//   //         parseInt(String(b?.user_id).match(/\d+/)?.[0] || 0),
//   //     );
//   //   } else if (idSort === "desc") {
//   //     users.sort(
//   //       (a, b) =>
//   //         parseInt(String(b?.user_id).match(/\d+/)?.[0] || 0) -
//   //         parseInt(String(a?.user_id).match(/\d+/)?.[0] || 0),
//   //     );
//   //   } else {
//   //     // default: highest ID first
//   //     users.sort(
//   //       (a, b) =>
//   //         parseInt(String(b?.user_id).match(/\d+/)?.[0] || 0) -
//   //         parseInt(String(a?.user_id).match(/\d+/)?.[0] || 0),
//   //     );
//   //   }
//   //   return users;
//   // }, [userData, nameSort, idSort]);

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [rowsPerPage, roleFilter]); // ← add roleFilter here

//   const sortedData = React.useMemo(() => {
//     let users = Array.isArray(userData) ? [...userData] : [];

//     // Apply role filter first
//     if (roleFilter === "student") {
//       users = users.filter((u) => u?.role_id === 1);
//     } else if (roleFilter === "teacher") {
//       users = users.filter((u) => u?.role_id === 2);
//     }

//     if (nameSort === "asc") {
//       users.sort((a, b) =>
//         (a?.firstname || "").localeCompare(b?.firstname || ""),
//       );
//     } else if (nameSort === "desc") {
//       users.sort((a, b) =>
//         (b?.firstname || "").localeCompare(a?.firstname || ""),
//       );
//     } else if (idSort === "asc") {
//       users.sort(
//         (a, b) =>
//           parseInt(String(a?.user_id).match(/\d+/)?.[0] || 0) -
//           parseInt(String(b?.user_id).match(/\d+/)?.[0] || 0),
//       );
//     } else if (idSort === "desc") {
//       users.sort(
//         (a, b) =>
//           parseInt(String(b?.user_id).match(/\d+/)?.[0] || 0) -
//           parseInt(String(a?.user_id).match(/\d+/)?.[0] || 0),
//       );
//     } else {
//       users.sort(
//         (a, b) =>
//           parseInt(String(b?.user_id).match(/\d+/)?.[0] || 0) -
//           parseInt(String(a?.user_id).match(/\d+/)?.[0] || 0),
//       );
//     }
//     return users;
//   }, [userData, nameSort, idSort, roleFilter]); // ← add roleFilter to deps

//   const toggleNameSort = () => {
//     setIdSort(null);
//     setNameSort((prev) =>
//       prev === "asc" ? "desc" : prev === "desc" ? null : "asc",
//     );
//   };

//   const toggleIdSort = () => {
//     setNameSort(null);
//     setIdSort((prev) =>
//       prev === "asc" ? "desc" : prev === "desc" ? null : "asc",
//     );
//   };

//   // -------------------------------------------- Pagination --------------------------------------------
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [rowsPerPage]);

//   const totalItems = sortedData?.length;
//   const totalPages = Math.max(1, Math.ceil(totalItems / rowsPerPage));
//   const startIndex = (currentPage - 1) * rowsPerPage;
//   const endIndex = startIndex + rowsPerPage;
//   const paginatedUsers = sortedData?.slice(startIndex, endIndex);

//   // -------------------------------------------- Actions --------------------------------------------
//   const handleAddNewUser = async () => {};

//   const handleReActivate = async (e, user) => {
//     e.preventDefault();
//     const payload = {
//       user_id: user?.user_id,
//       email_id: user?.email,
//     };
//     const result = await dispatch(reActivateUser(payload));
//     if (result.success) {
//       dispatch(getCSVUploadedData());
//     }
//   };

//   const handleDeActivate = async (e, user) => {
//     e.preventDefault();
//     const payload = {
//       user_id: user?.user_id,
//       email_id: user?.email,
//     };
//     const result = await dispatch(deActivateUser(payload));
//     if (result.success) {
//       dispatch(getCSVUploadedData());
//     }
//   };

//   const handleEditUser = (e, user) => {
//     e.preventDefault();
//     setUserToEdit(user);
//     setShowAddUser(true);
//     setOpenMenuId(null);
//   };

//   const handleCloseModal = () => {
//     setShowAddUser(false);
//     setUserToEdit(null);
//   };

//   // ------------------------------------------- select all ------------------------------------------

//   const handleSelectRow = (userId) => {
//     setSelectedUsers((prev) => {
//       const updated = new Set(prev);
//       if (updated.has(userId)) {
//         updated.delete(userId);
//       } else {
//         updated.add(userId);
//       }
//       return updated;
//     });
//   };

//   // ------------------------------------------------ Download Excel -------------------------------------

//   // ------------------------------------------- select all ------------------------------------------

//   // true only if EVERY row in the full filtered dataset is selected
//   const isAllSelectedOnPage =
//     sortedData?.length > 0 &&
//     sortedData.every((u) => selectedUsers.has(u.user_id));

//   const handleSelectAll = (e) => {
//     const checked = e.target.checked;
//     setSelectedUsers((prev) => {
//       const updated = new Set(prev);
//       sortedData.forEach((u) => {
//         if (checked) {
//           updated.add(u.user_id);
//         } else {
//           updated.delete(u.user_id);
//         }
//       });
//       return updated;
//     });
//   };
//   const handleDownloadExcel = async () => {
//     const XLSX = await import("xlsx");
//     const rowsToExport = sortedData.filter((u) => selectedUsers.has(u.user_id));

//     if (rowsToExport.length === 0) {
//       setToastState({
//         show: true,
//         message: "Please select atleast one user to export.",
//         type: "error",
//       });
//       return;
//     }

//     const exportData = rowsToExport.map((u) => ({
//       "User ID": u?.user_id || "N/A",
//       "First Name": u?.firstname || "N/A",
//       "Last Name": u?.lastname || "N/A",
//       Email: u?.email || "N/A",
//       Grade: u?.classes
//         ?.map((c) => `${c?.grade || "N/A"}${c?.division || ""}`)
//         .join(", "),
//       School: u?.school || "N/A",
//       Role: u?.role_id === 2 ? "Teacher" : "Student",
//       Status: u?.status ? "Active" : "Inactive",
//     }));

//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
//     setSelectedUsers(new Set());

//     XLSX.writeFile(
//       workbook,
//       `selected-users-${new Date().toISOString().slice(0, 10)}.xlsx`,
//     );
//   };

//   // -------------------------------------------- Filter Logic --------------------------------------------

//   //  Central filter — reads from ref so it's never stale
//   const applyFilters = (filters, query = searchQuery) => {
//     let filtered = userData1Ref.current || [];

//     // Apply search query
//     if (query) {
//       const q = query.toLowerCase();
//       filtered = filtered.filter(
//         (item) =>
//           item?.firstname?.toLowerCase()?.includes(q) ||
//           item?.lastname?.toLowerCase()?.includes(q) ||
//           item?.user_id?.toString()?.includes(q) ||
//           item?.email?.toLowerCase()?.includes(q),
//       );
//     }

//     // Apply column filters — categories are AND, tags within a category are OR
//     Object.entries(filters).forEach(([category, tags]) => {
//       if (!tags || tags.length === 0) return;
//       filtered = filtered.filter((item) =>
//         tags.some((tag) => {
//           const t = tag.toLowerCase();
//           switch (category) {
//             case "first name":
//               return item?.firstname?.toLowerCase()?.includes(t);
//             case "last name":
//               return item?.lastname?.toLowerCase()?.includes(t);
//             case "class":
//               return item?.classes?.some((c) =>
//                 c?.grade?.toString()?.includes(t),
//               );
//             case "division":
//               return item?.classes?.some((c) =>
//                 c?.division?.toLowerCase()?.includes(t),
//               );
//             default:
//               return true;
//           }
//         }),
//       );
//     });

//     setUserData(filtered);
//   };

//   // Single unified useEffect for search — no duplicate
//   useEffect(() => {
//     const id = setTimeout(() => {
//       applyFilters(activeFilters, searchQuery);
//     }, 500);
//     return () => clearTimeout(id);
//   }, [searchQuery, userData1]);

//   const handleSearchFilter = (e) => {
//     setSearchQuery(e.target.value);
//   };

//   const handleInputChange = (category, value) => {
//     setInputValues((prev) => ({ ...prev, [category]: value }));

//     if (value.includes(",")) {
//       const newTags = value
//         .split(",")
//         .map((v) => v.trim())
//         .filter((v) => v !== "");
//       const existingTags = activeFiltersRef.current[category] || [];
//       const combinedTags = [...new Set([...existingTags, ...newTags])];
//       const updatedFilters = {
//         ...activeFiltersRef.current,
//         [category]: combinedTags,
//       };

//       activeFiltersRef.current = updatedFilters;
//       setActiveFilters(updatedFilters);
//       setInputValues((prev) => ({ ...prev, [category]: "" }));
//       applyFilters(updatedFilters);
//     } else {
//       const trimmed = value.trim();
//       const updatedFilters = { ...activeFiltersRef.current };

//       if (trimmed) {
//         updatedFilters[category] = [trimmed];
//       } else {
//         delete updatedFilters[category];
//       }

//       activeFiltersRef.current = updatedFilters;
//       setActiveFilters(updatedFilters);
//       applyFilters(updatedFilters);
//     }
//   };

//   const handleKeyDown = (e, category) => {
//     if (e.key === "Enter") {
//       e.preventDefault();
//       const value = inputValues[category]?.trim();
//       if (!value) return;

//       const existingTags = activeFiltersRef.current[category] || [];
//       if (existingTags.includes(value)) return;

//       const updatedFilters = {
//         ...activeFiltersRef.current,
//         [category]: [...existingTags, value],
//       };
//       activeFiltersRef.current = updatedFilters;
//       setActiveFilters(updatedFilters);
//       setInputValues((prev) => ({ ...prev, [category]: "" }));
//       applyFilters(updatedFilters);
//     }
//   };

//   const clearCategory = (category) => {
//     const updatedFilters = { ...activeFiltersRef.current };
//     delete updatedFilters[category];
//     activeFiltersRef.current = updatedFilters;
//     setActiveFilters(updatedFilters);
//     setInputValues((prev) => ({ ...prev, [category]: "" }));
//     applyFilters(updatedFilters);
//   };

//   const removeTag = (category, tag) => {
//     const updatedTags = activeFiltersRef.current[category].filter(
//       (t) => t !== tag,
//     );
//     const updatedFilters = { ...activeFiltersRef.current };
//     if (updatedTags.length === 0) {
//       delete updatedFilters[category];
//     } else {
//       updatedFilters[category] = updatedTags;
//     }
//     activeFiltersRef.current = updatedFilters;
//     setActiveFilters(updatedFilters);
//     applyFilters(updatedFilters);
//   };

//   // -------------------------------------------- Render --------------------------------------------
//   return (
//     <div className="user-wrapper">
//       <style>{`
//         .user-wrapper {
//           width: 100%;
//           height: calc(100vh - 120px);
//           display: flex;
//           flex-direction: column;
//           background-color: #f9f9f9;
//           box-sizing: border-box;
//           overflow: hidden;
//         }

//         .user-toolbar, .record-row, .pagination {
//           flex-shrink: 0;
//         }

//         .table-container {
//           flex: 1;
//           width: 100%;
//           min-height: 0;
//           overflow-y: auto;
//           overflow-x: auto;
//           border: 1px solid #e0e0e0;
//           background: white;
//           border-radius: 4px;
//           // margin-bottom: 10px;
//         }

//         .table-container table {
//           width: 100%;
//           border-collapse: collapse;
//         }

//         .table-container table thead th {
//           position: sticky;
//           top: 0;
//           background: #f4f6f8;
//           z-index: 10;
//           padding: 10px;
//           text-align: left;
//           border-bottom: 2px solid #ddd;
//           box-shadow: 0 2px 2px -1px rgba(0,0,0,0.1);
//         }

//         .record-row {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 10px;
//           font-size: 12px;
//           color: #666;
//           width: 100%;
//         }

//         .page-size select {
//           margin-left: 5px;
//           padding: 3px;
//           border: 1px solid #ccc;
//           border-radius: 4px;
//         }

//         .pagination {
//           width: 100%;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           border-top: 1px solid #eee;
//           background: #f9f9f9;
//         }

//         .page-controls {
//           display: flex;
//           align-items: center;
//           gap: 5px;
//         }

//         .page-controls button {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           height: 32px;
//           min-width: 32px;
//           padding: 0 10px;
//           border: px solid #ccc;
//           background: white;
//           cursor: pointer;
//           border-radius: 3px;
//           line-height: 1;
//         }

//         .page-controls button:disabled {
//           opacity: 0.5;
//           cursor: not-allowed;
//         }

//         .current-page {
//           margin: 0 10px;
//           font-size: 12px;
//         }
//       `}</style>

//       {showAddUser && (
//         <AddNewUser onCancel={handleCloseModal} userData={userToEdit} />
//       )}

//       {showBulkUpload && (
//         <BulkUpload
//           onCancel={() => setShowBulkUpload(false)}
//           onUploadComplete={(data) => setLastUploadData(data)}
//         />
//       )}

//       {showAddSingleUserModal && (
//         <AddSingleUser onCancel={() => setShowAddSingleUserModal(false)} />
//       )}

//       <div className="user-toolbar">
//         <input
//           className="search-input"
//           placeholder="search..."
//           onChange={handleSearchFilter}
//           value={searchQuery}
//         />

//         <div className="actions actions-container">
//           <div className="filter-wrapper" ref={dropdownRef}>
//             <button
//               className="btn outline btn-filter"
//               onClick={() => setOpenFilter(!openFilter)}
//             >
//               <svg
//                 width="14"
//                 height="14"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2.5"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               >
//                 <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
//               </svg>
//               Filter{" "}
//               {Object.keys(activeFilters).length > 0 && (
//                 <span className="filter-badge">
//                   {Object.values(activeFilters).reduce(
//                     (acc, curr) => acc + curr.length,
//                     0,
//                   )}
//                 </span>
//               )}
//             </button>

//             {openFilter && (
//               <div className="menu-dropdown filter-dropdown-panel">
//                 <div className="filter-header">
//                   <span className="filter-title">Filters</span>
//                   <span
//                     onClick={() => {
//                       setActiveFilters({});
//                       setInputValues({});
//                       applyFilters({}, searchQuery);
//                     }}
//                     className="filter-clear-btn"
//                   >
//                     CLEAR ALL
//                   </span>
//                 </div>

//                 <div className="filter-grid">
//                   {FILTER_OPTIONS.map((option) => (
//                     <div key={option} className="filter-item-container">
//                       <div className="filter-label-row">
//                         <label className="filter-label">{option}</label>
//                         {activeFilters[option]?.length > 0 && (
//                           <span
//                             onClick={() => clearCategory(option)}
//                             className="filter-reset-btn"
//                           >
//                             Reset
//                           </span>
//                         )}
//                       </div>

//                       <input
//                         className="filter-sub-input filter-search-input"
//                         placeholder={`Search ${option}...`}
//                         value={inputValues[option] || ""}
//                         onChange={(e) =>
//                           handleInputChange(option, e.target.value)
//                         }
//                         onKeyDown={(e) => handleKeyDown(e, option)}
//                       />

//                       <div className="filter-tags-wrapper">
//                         {activeFilters[option]?.map((tag) => (
//                           <div key={tag} className="filter-tag">
//                             {tag}
//                             <span
//                               onClick={() => removeTag(option, tag)}
//                               className="filter-tag-remove"
//                             >
//                               ×
//                             </span>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             )}
//           </div>

//           <button
//             className="btn primary"
//             onClick={() => setShowAddSingleUserModal(true)}
//           >
//             + New User
//           </button>
//           <button
//             className="btn primary btn-black"
//             onClick={() => setShowBulkUpload(true)}
//           >
//             Bulk Upload
//           </button>

//           <button
//             className="btn outline"
//             onClick={() => setShowUploadSummary(true)}
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: "6px",
//               borderColor: "#6366f1",
//               color: "#6366f1",
//               fontWeight: 600,
//             }}
//           >
//             <svg
//               width="14"
//               height="14"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth="2.5"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             >
//               <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
//               <polyline points="14 2 14 8 20 8" />
//               <line x1="16" y1="13" x2="8" y2="13" />
//               <line x1="16" y1="17" x2="8" y2="17" />
//               <polyline points="10 9 9 9 8 9" />
//             </svg>
//             Summary
//           </button>

//           <button
//             className="btn outline"
//             onClick={handleDownloadExcel}
//             // disabled={selectedUsers.size === 0}
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: "6px",
//               borderColor: "#16a34a",
//               color: "#16a34a",
//               fontWeight: 600,
//               opacity: selectedUsers.size === 0 ? 0.5 : 1,
//               // cursor: selectedUsers.size === 0 ? "not-allowed" : "pointer",
//             }}
//           >
//             <svg
//               width="14"
//               height="14"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth="2.5"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             >
//               <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
//               <polyline points="7 10 12 15 17 10" />
//               <line x1="12" y1="15" x2="12" y2="3" />
//             </svg>
//             Excel {selectedUsers.size > 0 && `(${selectedUsers.size})`}
//           </button>
//         </div>
//       </div>

//       <div className="record-row">
//         <span>
//           Total: <strong>{sortedData?.length || 0}</strong>
//         </span>
//         <div className="table-controls">
//           <div>
//             <label>Sort By First Name:</label>
//             <select
//               value={nameSort || ""}
//               onChange={(e) => {
//                 setIdSort(null);
//                 setNameSort(e.target.value || null);
//               }}
//               className="sort-dropdown"
//             >
//               <option value="">default</option>
//               <option value="asc">A → Z</option>
//               <option value="desc">Z → A</option>
//             </select>
//           </div>
//           <div>
//             <span className="mx-3"></span>
//             <label > Role:</label>
//             <select
//               value={roleFilter}
//               onChange={(e) => setRoleFilter(e.target.value)}
//               className="sort-dropdown"
//             >
//               <option value="all">All</option>
//               <option value="student">Student</option>
//               <option value="teacher">Teacher</option>
//             </select>
//           </div>
//         </div>
//       </div>

//       <div className="table-container">
//         <table
//           style={{
//             position: "relative",
//             zIndex: 1,
//             width: "100%",
//             borderCollapse: "collapse",
//           }}
//         >
//           <thead>
//             <tr>
//               <th>
//                 <input
//                   type="checkbox"
//                   checked={isAllSelectedOnPage}
//                   onChange={handleSelectAll}
//                 />
//               </th>
//               <th onClick={toggleIdSort} className="sortable">
//                 ID {idSort === "asc" ? "↑" : idSort === "desc" ? "↓" : "⇅"}
//               </th>
//               <th>First Name</th>
//               <th>Last Name</th>
//               <th>Email</th>
//               <th>Grade</th>
//               <th>School</th>

//               <th>Role</th>
//               <th>Status</th>
//               <th></th>
//             </tr>
//           </thead>
//           <tbody>
//             {(paginatedUsers || []).map((u, index) => (
//               <tr key={u?.user_id}>
//                 <td>
//                   <input
//                     type="checkbox"
//                     checked={selectedUsers.has(u?.user_id)}
//                     onChange={() => handleSelectRow(u?.user_id)}
//                   />
//                 </td>

//                 <td>{u?.user_id || "N/A"}</td>

//                 <td>{u?.firstname || "N/A"}</td>

//                 <td>{u?.lastname || "N/A"}</td>

//                 <td>{u?.email || "NA"}</td>

//                 <td>
//                   {u?.classes
//                     ?.map(
//                       (c) =>
//                         `${c?.grade || "N/A"}${c?.division ? c?.division : ""}`,
//                     )
//                     .join(", ")}
//                 </td>

//                 <td>{u?.school || "N/A"}</td>

//                 <td>
//                   <select
//                     value={u?.role_id}
//                     onChange={async (e) => {
//                       const newRoleId = Number(e.target.value);
//                       const previousRoleId = u?.role_id;

//                       const payload = {
//                         role_id: newRoleId,
//                       };

//                       const result = await dispatch(
//                         changeRole(payload, u?.user_id),
//                       );

//                       if (result.success) {
//                         // Update only this user's role_id in local state
//                         setUserData((prev) =>
//                           prev.map((user) =>
//                             user.user_id === u.user_id
//                               ? { ...user, role_id: newRoleId }
//                               : user,
//                           ),
//                         );
//                         setUserData1((prev) =>
//                           prev.map((user) =>
//                             user.user_id === u.user_id
//                               ? { ...user, role_id: newRoleId }
//                               : user,
//                           ),
//                         );

//                         setToastState({
//                           show: true,
//                           message: "Role updated successfully.",
//                           type: "success",
//                         });
//                       } else {
//                         // API call failed — don't touch local state, dropdown reverts
//                         // to previousRoleId automatically since `value={u?.role_id}` is
//                         // still bound to the unchanged source data.
//                         setToastState({
//                           show: true,
//                           message:
//                             result.message ||
//                             "Failed to update role. Please try again.",
//                           type: "error",
//                         });
//                       }
//                     }}
//                     className="role-dropdown"
//                   >
//                     <option value={1}>Student</option>
//                     <option value={2}>Teacher</option>
//                   </select>
//                 </td>

//                 <td>
//                   <span>
//                     {u?.status === true ? (
//                       <span className="row-active">Active</span>
//                     ) : (
//                       <span className="row-deactive">Inactive</span>
//                     )}
//                   </span>
//                 </td>

//                 <td
//                   className="menu-cell"
//                   ref={(el) => (menuRef.current[index] = el)}
//                 >
//                   <span
//                     className="menu"
//                     onClick={() =>
//                       setOpenMenuId(openMenuId === index ? null : index)
//                     }
//                   >
//                     ⋮
//                   </span>

//                   {openMenuId === index && (
//                     <div
//                       className="menu-dropdown"
//                       ref={(el) => (menuRef.current[index] = el)}
//                     >
//                       <div
//                         className={`menu-item ${
//                           u?.status ? "active-item" : ""
//                         }`}
//                         onClick={(e) => {
//                           handleReActivate(e, u);
//                           setOpenMenuId(null);
//                         }}
//                       >
//                         active
//                       </div>

//                       <div
//                         className={`menu-item ${
//                           !u?.status ? "deactive-item" : ""
//                         }`}
//                         onClick={(e) => {
//                           handleDeActivate(e, u);
//                           setOpenMenuId(null);
//                         }}
//                       >
//                         inactive
//                       </div>

//                       <div
//                         className="menu-item"
//                         onClick={(e) => {
//                           handleEditUser(e, u);
//                           setOpenMenuId(null);
//                         }}
//                       >
//                         edit
//                       </div>
//                     </div>
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       <div className="pagination">
//         {/* <div className="page-info">
//           Showing {startIndex + 1}–{Math.min(endIndex, userData?.length)} of{" "}
//           {userData?.length}
//         </div> */}
//         <div className="page-info">
//           Showing {startIndex + 1}–{Math.min(endIndex, sortedData?.length)} of{" "}
//           {sortedData?.length}
//         </div>
//         <div className="page-controls">
//           <button
//             disabled={currentPage === 1}
//             onClick={() => setCurrentPage(1)}
//           >
//             |‹
//           </button>
//           <button
//             disabled={currentPage === 1}
//             onClick={() => setCurrentPage((p) => p - 1)}
//           >
//             ‹
//           </button>
//           <span className="current-page">
//             Page {currentPage} of {totalPages}
//           </span>
//           <button
//             disabled={currentPage === totalPages}
//             onClick={() => setCurrentPage((p) => p + 1)}
//           >
//             ›
//           </button>
//           <button
//             disabled={currentPage === totalPages}
//             onClick={() => setCurrentPage(totalPages)}
//           >
//             ›|
//           </button>
//         </div>
//         <div className="page-size">
//           Rows:{" "}
//           <select
//             value={rowsPerPage}
//             onChange={(e) => setRowsPerPage(Number(e.target.value))}
//           >
//             <option value={10}>10</option>
//             <option value={20}>20</option>
//             <option value={30}>30</option>
//             <option value={40}>40</option>
//             <option value={50}>50</option>
//           </select>
//         </div>
//       </div>

//       {showUploadSummary && userData1 && (
//         <UploadSummaryModal
//           data={userData1}
//           onClose={() => setShowUploadSummary(false)}
//         />
//       )}
//       <ToastMessage
//         show={toastState.show}
//         onClose={() => setToastState({ show: false, message: "", type: "" })}
//         message={toastState.message}
//         type={toastState.type}
//       />
//     </div>
//   );
// }

import React, { useEffect, useRef, useState } from "react";
import "./people.scss";
import AddNewUser from "./editUser";
import BulkUpload from "./BulkUpload/BulkUpload";
import UploadSummaryModal from "./BulkUpload/UploadSummaryModal";
import { useDispatch, useSelector } from "react-redux";
import {
  addNewUser,
  analyticsReport,
  changeRole,
  deActivateUser,
  getCSVUploadedData,
  reActivateUser,
} from "../../Redux/Admin_Panel/people/people.action";
import { PATCH_MULTIPLE_STATUS_UPDATE, REACTIVATE_USER } from "../../utils/api";
import { useNavigate } from "react-router-dom";
import AddSingleUser from "./addSingleUser";
import * as XLSX from "xlsx";
import ToastMessage from "../../utils/toasts/toastMessage";
import { RotateCcw } from "lucide-react";
import { apiRequest } from "../../api/apiRequest";
import Loader from "../../utils/loader/loader";

const FILTER_OPTIONS = [
  // "id",
  "class",
  "division",
  "first name",
  "last name",
];

export default function PeopleBodyPage() {
  const dispatch = useDispatch();
  const nav = useNavigate();

  const store = useSelector((state) => state);
  const csvDataStore = useSelector(
    (state) => state?.AdminPeopleManager?.csvData,
  );

  const [openFilter, setOpenFilter] = useState(false);
  const [userData, setUserData] = useState(null);
  const [userData1, setUserData1] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [openMenuId, setOpenMenuId] = useState(null);
  const [showAddUser, setShowAddUser] = useState(false);
  const [showBulkUpload, setShowBulkUpload] = useState(false);
  const [showAddSingleUserModal, setShowAddSingleUserModal] = useState(false);
  const [lastUploadData, setLastUploadData] = useState(null);
  const [showUploadSummary, setShowUploadSummary] = useState(false);

  const [nameSort, setNameSort] = useState("");
  const [idSort, setIdSort] = useState(null);

  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });
  const [roleFilter, setRoleFilter] = useState("all");
  const [schoolFilter, setSchoolFilter] = useState("all");
  const [selectedUsers, setSelectedUsers] = useState(new Set());
  const [showStatusMenu, setShowStatusMenu] = useState(false);
  const statusMenuRef = useRef(null);

  const [statusConfirm, setStatusConfirm] = useState({
    show: false,
    action: null,
  });
  const [bulkLoading, setBulkLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  // New State to track the user being edited
  const [inputValues, setInputValues] = useState({});
  const [userToEdit, setUserToEdit] = useState(null);
  const [activeFilters, setActiveFilters] = useState({});

  const [roleId, setRoleId] = useState(0);

  const dropdownRef = useRef(null);
  const menuRef = useRef({});
  const userData1Ref = useRef(null);
  const activeFiltersRef = useRef({});

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  //  Keep ref in sync with state
  useEffect(() => {
    userData1Ref.current = userData1;
  }, [userData1]);

  // Keep ref in sync with state (near your other useEffects)
  useEffect(() => {
    activeFiltersRef.current = activeFilters;
  }, [activeFilters]);

  useEffect(() => {
    if (csvDataStore?.users?.length > 0) {
      const reversed = [...csvDataStore.users].reverse();
      setUserData(reversed);
      setUserData1(reversed);
    } else {
    }
  }, [csvDataStore]);

  useEffect(() => {
    dispatch(getCSVUploadedData());
  }, [dispatch]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        openMenuId !== null &&
        menuRef.current[openMenuId] &&
        !menuRef.current[openMenuId].contains(e.target)
      ) {
        setOpenMenuId(null);
      }

      if (
        openFilter &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setOpenFilter(false);
      }

      if (
        showStatusMenu &&
        statusMenuRef.current &&
        !statusMenuRef.current.contains(e.target)
      ) {
        setShowStatusMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openMenuId, openFilter, showStatusMenu]);

  //-------------------------------------------- unique schools (for dropdown) --------------------------------------------

  const uniqueSchools = React.useMemo(() => {
    const schoolMap = new Map();

    (userData1 || []).forEach((u) => {
      const school = u?.school?.trim();
      if (school) {
        const key = school.toLowerCase();
        if (!schoolMap.has(key)) {
          schoolMap.set(key, school); // keeps the first encountered casing
        }
      }
    });

    return [...schoolMap.values()].sort();
  }, [userData1]);

  //-------------------------------------------- user sorting --------------------------------------------

  useEffect(() => {
    setCurrentPage(1);
  }, [rowsPerPage, roleFilter, schoolFilter]); // ← added schoolFilter here

  const sortedData = React.useMemo(() => {
    let users = Array.isArray(userData) ? [...userData] : [];

    // Apply role filter first
    if (roleFilter === "student") {
      users = users.filter((u) => u?.role_id === 1);
    } else if (roleFilter === "teacher") {
      users = users.filter((u) => u?.role_id === 2);
    }

    // Apply school filter
    if (schoolFilter !== "all") {
      users = users.filter((u) => u?.school === schoolFilter);
    }

    if (nameSort === "asc") {
      users.sort((a, b) =>
        (a?.firstname || "").localeCompare(b?.firstname || ""),
      );
    } else if (nameSort === "desc") {
      users.sort((a, b) =>
        (b?.firstname || "").localeCompare(a?.firstname || ""),
      );
    } else if (idSort === "asc") {
      users.sort(
        (a, b) =>
          parseInt(String(a?.user_id).match(/\d+/)?.[0] || 0) -
          parseInt(String(b?.user_id).match(/\d+/)?.[0] || 0),
      );
    } else if (idSort === "desc") {
      users.sort(
        (a, b) =>
          parseInt(String(b?.user_id).match(/\d+/)?.[0] || 0) -
          parseInt(String(a?.user_id).match(/\d+/)?.[0] || 0),
      );
    } else {
      users.sort(
        (a, b) =>
          parseInt(String(b?.user_id).match(/\d+/)?.[0] || 0) -
          parseInt(String(a?.user_id).match(/\d+/)?.[0] || 0),
      );
    }
    return users;
  }, [userData, nameSort, idSort, roleFilter, schoolFilter]); // ← added schoolFilter to deps

  const toggleNameSort = () => {
    setIdSort(null);
    setNameSort((prev) =>
      prev === "asc" ? "desc" : prev === "desc" ? null : "asc",
    );
  };

  const toggleIdSort = () => {
    setNameSort(null);
    setIdSort((prev) =>
      prev === "asc" ? "desc" : prev === "desc" ? null : "asc",
    );
  };

  // -------------------------------------------- Pagination --------------------------------------------
  useEffect(() => {
    setCurrentPage(1);
  }, [rowsPerPage]);

  const totalItems = sortedData?.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / rowsPerPage));
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedUsers = sortedData?.slice(startIndex, endIndex);

  // -------------------------------------------- Actions --------------------------------------------
  const handleAddNewUser = async () => {};

  const handleReActivate = async (e, user) => {
    e.preventDefault();
    const payload = {
      user_id: user?.user_id,
      email_id: user?.email,
    };
    const result = await dispatch(reActivateUser(payload));
    if (result.success) {
      dispatch(getCSVUploadedData());
    }
  };

  const handleDeActivate = async (e, user) => {
    e.preventDefault();
    const payload = {
      user_id: user?.user_id,
      email_id: user?.email,
    };
    const result = await dispatch(deActivateUser(payload));
    if (result.success) {
      dispatch(getCSVUploadedData());
    }
  };

  const handleEditUser = (e, user) => {
    e.preventDefault();
    setUserToEdit(user);
    setShowAddUser(true);
    setOpenMenuId(null);
  };

  const handleCloseModal = () => {
    setShowAddUser(false);
    setUserToEdit(null);
  };

  // ------------------------------------------- select all ------------------------------------------

  const handleSelectRow = (userId) => {
    setSelectedUsers((prev) => {
      const updated = new Set(prev);
      if (updated.has(userId)) {
        updated.delete(userId);
      } else {
        updated.add(userId);
      }
      return updated;
    });
  };

  // ------------------------------------------- bulk status change ------------------------------------------

  const openStatusConfirm = (action) => {
    if (selectedUsers.size === 0) return;
    setShowStatusMenu(false);
    setStatusConfirm({ show: true, action});
  };

  const closeStatusConfirm = () => {
    if (bulkLoading) return;
    setStatusConfirm({ show: false, action: null });
  };

  const handleBulkStatusChange = async () => {
    const usersToUpdate = sortedData.filter((u) =>
      selectedUsers.has(u.user_id),
    );

    if (usersToUpdate.length === 0) {
      setStatusConfirm({ show: false, action: null });
      return;
    }

    const payload = {
      user_ids: Array.from(selectedUsers),
      action: statusConfirm.action === true ? "active" : "deactive",
    }
     const result = await apiRequest("patch", PATCH_MULTIPLE_STATUS_UPDATE, payload);
    
      setLoading(false);
    
      if (!result.success) {
        setBulkLoading(false);
        setToastState({
          show: true,
          message: result.message || "Error on updating status!",
          type: "error",
        });
        return;
      }
    
      setToastState({
        show: true,
        message: result.message ||"Users status updated successfully!",
        type: "success",
      });
    
      dispatch(getCSVUploadedData());
      setBulkLoading(false);
      setStatusConfirm({ show: false, action: null });
      setSelectedUsers(new Set());
  };

  // ------------------------------------------------ Download Excel -------------------------------------

  // true only if EVERY row in the full filtered dataset is selected
  const isAllSelectedOnPage =
    sortedData?.length > 0 &&
    sortedData.every((u) => selectedUsers.has(u.user_id));

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectedUsers((prev) => {
      const updated = new Set(prev);
      sortedData.forEach((u) => {
        if (checked) {
          updated.add(u.user_id);
        } else {
          updated.delete(u.user_id);
        }
      });
      return updated;
    });
  };
  const handleDownloadExcel = async () => {
    const XLSX = await import("xlsx");
    const rowsToExport = sortedData.filter((u) => selectedUsers.has(u.user_id));

    if (rowsToExport.length === 0) {
      setToastState({
        show: true,
        message: "Please select atleast one user to export.",
        type: "error",
      });
      return;
    }

    const exportData = rowsToExport.map((u) => ({
      "User ID": u?.user_id || "N/A",
      "First Name": u?.firstname || "N/A",
      "Last Name": u?.lastname || "N/A",
      Email: u?.email || "N/A",
      Grade: u?.classes
        ?.map((c) => `${c?.grade || "N/A"}${c?.division || ""}`)
        .join(", "),
      School: u?.school || "N/A",
      Role: u?.role_id === 2 ? "Teacher" : "Student",
      Status: u?.status ? "Active" : "Inactive",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
    setSelectedUsers(new Set());

    XLSX.writeFile(
      workbook,
      `selected-users-${new Date().toISOString().slice(0, 10)}.xlsx`,
    );
  };

  // -------------------------------------------- Filter Logic --------------------------------------------

  //  Central filter — reads from ref so it's never stale
  const applyFilters = (filters, query = searchQuery) => {
    let filtered = userData1Ref.current || [];

    // Apply search query
    if (query) {
      const q = query.toLowerCase();
      filtered = filtered.filter(
        (item) =>
          item?.firstname?.toLowerCase()?.includes(q) ||
          item?.lastname?.toLowerCase()?.includes(q) ||
          item?.user_id?.toString()?.includes(q) ||
          item?.email?.toLowerCase()?.includes(q),
      );
    }

    // Apply column filters — categories are AND, tags within a category are OR
    Object.entries(filters).forEach(([category, tags]) => {
      if (!tags || tags.length === 0) return;
      filtered = filtered.filter((item) =>
        tags.some((tag) => {
          const t = tag.toLowerCase();
          switch (category) {
            case "first name":
              return item?.firstname?.toLowerCase()?.includes(t);
            case "last name":
              return item?.lastname?.toLowerCase()?.includes(t);
            case "class":
              return item?.classes?.some((c) =>
                c?.grade?.toString()?.includes(t),
              );
            case "division":
              return item?.classes?.some((c) =>
                c?.division?.toLowerCase()?.includes(t),
              );
            default:
              return true;
          }
        }),
      );
    });

    setUserData(filtered);
  };

  // Single unified useEffect for search — no duplicate
  useEffect(() => {
    const id = setTimeout(() => {
      applyFilters(activeFilters, searchQuery);
    }, 500);
    return () => clearTimeout(id);
  }, [searchQuery, userData1]);

  const handleSearchFilter = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleInputChange = (category, value) => {
    setInputValues((prev) => ({ ...prev, [category]: value }));

    if (value.includes(",")) {
      const newTags = value
        .split(",")
        .map((v) => v.trim())
        .filter((v) => v !== "");
      const existingTags = activeFiltersRef.current[category] || [];
      const combinedTags = [...new Set([...existingTags, ...newTags])];
      const updatedFilters = {
        ...activeFiltersRef.current,
        [category]: combinedTags,
      };

      activeFiltersRef.current = updatedFilters;
      setActiveFilters(updatedFilters);
      setInputValues((prev) => ({ ...prev, [category]: "" }));
      applyFilters(updatedFilters);
    } else {
      const trimmed = value.trim();
      const updatedFilters = { ...activeFiltersRef.current };

      if (trimmed) {
        updatedFilters[category] = [trimmed];
      } else {
        delete updatedFilters[category];
      }

      activeFiltersRef.current = updatedFilters;
      setActiveFilters(updatedFilters);
      applyFilters(updatedFilters);
    }
  };

  const handleKeyDown = (e, category) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const value = inputValues[category]?.trim();
      if (!value) return;

      const existingTags = activeFiltersRef.current[category] || [];
      if (existingTags.includes(value)) return;

      const updatedFilters = {
        ...activeFiltersRef.current,
        [category]: [...existingTags, value],
      };
      activeFiltersRef.current = updatedFilters;
      setActiveFilters(updatedFilters);
      setInputValues((prev) => ({ ...prev, [category]: "" }));
      applyFilters(updatedFilters);
    }
  };

  const clearCategory = (category) => {
    const updatedFilters = { ...activeFiltersRef.current };
    delete updatedFilters[category];
    activeFiltersRef.current = updatedFilters;
    setActiveFilters(updatedFilters);
    setInputValues((prev) => ({ ...prev, [category]: "" }));
    applyFilters(updatedFilters);
  };

  const removeTag = (category, tag) => {
    const updatedTags = activeFiltersRef.current[category].filter(
      (t) => t !== tag,
    );
    const updatedFilters = { ...activeFiltersRef.current };
    if (updatedTags.length === 0) {
      delete updatedFilters[category];
    } else {
      updatedFilters[category] = updatedTags;
    }
    activeFiltersRef.current = updatedFilters;
    setActiveFilters(updatedFilters);
    applyFilters(updatedFilters);
  };

  // ------------------------------------------- clear ALL filters (search, role, school, sort, column filters) ------------------------------------------

  const areAnyFiltersActive =
    searchQuery !== "" ||
    roleFilter !== "all" ||
    schoolFilter !== "all" ||
    nameSort !== "" ||
    idSort !== null ||
    Object.keys(activeFilters).length > 0;

  const handleClearAllFilters = () => {
    setSearchQuery("");
    setRoleFilter("all");
    setSchoolFilter("all");
    setNameSort("");
    setIdSort(null);
    setActiveFilters({});
    setInputValues({});
    activeFiltersRef.current = {};
    setUserData(userData1Ref.current || []);
  };

  // -------------------------------------------- Render --------------------------------------------
  return (
    <div className="user-wrapper">
      <style>{`
        .user-wrapper {
          width: 100%;
          height: calc(100vh - 120px);
          display: flex;
          flex-direction: column;
          background-color: #f9f9f9;
          box-sizing: border-box;
          overflow: hidden;
        }

        .user-toolbar, .record-row, .pagination {
          flex-shrink: 0;
        }

        .table-container {
          flex: 1;
          width: 100%;
          min-height: 0;
          overflow-y: auto;
          overflow-x: auto;
          border: 1px solid #e0e0e0;
          background: white;
          border-radius: 4px;
        }

        .table-container table {
          width: 100%;
          border-collapse: collapse;
        }

        .table-container table thead th {
          position: sticky;
          top: 0;
          background: #f4f6f8;
          z-index: 10;
          padding: 10px;
          text-align: left;
          border-bottom: 2px solid #ddd;
          box-shadow: 0 2px 2px -1px rgba(0,0,0,0.1);
        }

        .record-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          font-size: 12px;
          color: #666;
          width: 100%;
        }

        .page-size select {
          margin-left: 5px;
          padding: 3px;
          border: 1px solid #ccc;
          border-radius: 4px;
        }

        .pagination {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid #eee;
          background: #f9f9f9;
        }

        .page-controls {
          display: flex;
          align-items: center;
          gap: 5px;
        }

        .page-controls button {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 32px;
          min-width: 32px;
          padding: 0 10px;
          border: px solid #ccc;
          background: white;
          cursor: pointer;
          border-radius: 3px;
          line-height: 1;
        }

        .page-controls button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .current-page {
          margin: 0 10px;
          font-size: 12px;
        }

        .status-confirm-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.4);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
        }

        .status-confirm-box {
          background: white;
          padding: 24px;
          border-radius: 8px;
          min-width: 320px;
          max-width: 400px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.15);
        }

        .status-confirm-box p {
          margin: 0 0 20px 0;
          font-size: 14px;
          color: #333;
          line-height: 1.4;
        }

        .status-confirm-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
        }

        .status-menu-wrapper {
          position: relative;
          display: inline-block;
        }

        .status-menu-dropdown {
          position: absolute;
          top: calc(100% + 4px);
          left: 0;
          background: white;
          border: 1px solid #e0e0e0;
          border-radius: 6px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.12);
          min-width: 160px;
          z-index: 50;
          overflow: hidden;
        }

        .status-menu-item {
          padding: 10px 14px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .status-menu-item:hover {
          background: #f4f6f8;
        }

        .status-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          display: inline-block;
        }

        .clear-filters-btn {
          background: transparent;
          border: none;
          color: #dc2626;
          font-size: 12px;
          font-weight: 600;
          cursor: pointer;
          text-decoration: underline;
          padding: 0;
          margin-left: 14px;
        }

        .clear-filters-btn:disabled {
          color: #aaa;
          cursor: not-allowed;
          text-decoration: none;
        }
      `}</style>

      {showAddUser && (
        <AddNewUser onCancel={handleCloseModal} userData={userToEdit} />
      )}

      {showBulkUpload && (
        <BulkUpload
          onCancel={() => setShowBulkUpload(false)}
          onUploadComplete={(data) => setLastUploadData(data)}
        />
      )}

      {showAddSingleUserModal && (
        <AddSingleUser onCancel={() => setShowAddSingleUserModal(false)} />
      )}

      {statusConfirm.show && (
        <div
          className="modal fade show"
          tabIndex={-1}
          aria-hidden="true"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="border-0 bdrs40 modal-content p-4 text-center">
              <button
                type="button"
                className="btn-close position-absolute end-0 top-0 m-3"
                onClick={closeStatusConfirm}
              />

              <h4 className="fw600 mb-3">Update</h4>

              <p className="mb-4">
                Are you sure you want to{" "}
                <strong>
                  {statusConfirm.action ? "activate" : "deactivate"}
                </strong>{" "}
                {selectedUsers.size} selected user
                {selectedUsers.size > 1 ? "s" : ""}?
              </p>

              <div className="d-flex justify-content-center gap-3">
                {/* <button
                      className="btn btn-outlined btn-outlined--dark px-4"
                        onClick={() => setShowConfirmModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-outlined btn-outlined--dark px-4"
                   
                       onClick={handleConfirmDelete}
                    >
                         Delete
                   
                    </button> */}
                <button
                  className="btn btn-outlined btn-outlined--dark px-4"
                  onClick={closeStatusConfirm}
                  disabled={bulkLoading}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-outlined btn-outlined--dark px-4"
                  onClick={handleBulkStatusChange}
                  disabled={bulkLoading}
                  style={{
                    backgroundColor: statusConfirm.action
                      ? "#16a34a"
                      : "#dc2626",
                    borderColor: statusConfirm.action ? "#16a34a" : "#dc2626",
                  }}
                >
                  {bulkLoading ? "Updating..." : "Confirm"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="user-toolbar">
        <input
          className="search-input"
          placeholder="search..."
          onChange={handleSearchFilter}
          value={searchQuery}
        />

        <div className="actions actions-container">
          <div className="filter-wrapper" ref={dropdownRef}>
            <button
              className="btn outline btn-filter"
              onClick={() => setOpenFilter(!openFilter)}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
              </svg>
              Filter{" "}
              {Object.keys(activeFilters).length > 0 && (
                <span className="filter-badge">
                  {Object.values(activeFilters).reduce(
                    (acc, curr) => acc + curr.length,
                    0,
                  )}
                </span>
              )}
            </button>

            {openFilter && (
              <div className="menu-dropdown filter-dropdown-panel">
                <div className="filter-header">
                  <span className="filter-title">Filters</span>
                  <span
                    onClick={() => {
                      setActiveFilters({});
                      setInputValues({});
                      applyFilters({}, searchQuery);
                    }}
                    className="filter-clear-btn"
                  >
                    CLEAR ALL
                  </span>
                </div>

                <div className="filter-grid">
                  {FILTER_OPTIONS.map((option) => (
                    <div key={option} className="filter-item-container">
                      <div className="filter-label-row">
                        <label className="filter-label">{option}</label>
                        {activeFilters[option]?.length > 0 && (
                          <span
                            onClick={() => clearCategory(option)}
                            className="filter-reset-btn"
                          >
                            Reset
                          </span>
                        )}
                      </div>

                      <input
                        className="filter-sub-input filter-search-input"
                        placeholder={`Search ${option}...`}
                        value={inputValues[option] || ""}
                        onChange={(e) =>
                          handleInputChange(option, e.target.value)
                        }
                        onKeyDown={(e) => handleKeyDown(e, option)}
                      />

                      <div className="filter-tags-wrapper">
                        {activeFilters[option]?.map((tag) => (
                          <div key={tag} className="filter-tag">
                            {tag}
                            <span
                              onClick={() => removeTag(option, tag)}
                              className="filter-tag-remove"
                            >
                              ×
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <button
            className="btn primary"
            onClick={() => setShowAddSingleUserModal(true)}
          >
            + New User
          </button>
          <button
            className="btn primary btn-black"
            onClick={() => setShowBulkUpload(true)}
          >
            Bulk Upload
          </button>

          <button
            className="btn outline"
            onClick={() => setShowUploadSummary(true)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              borderColor: "#6366f1",
              color: "#6366f1",
              fontWeight: 600,
            }}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
              <polyline points="10 9 9 9 8 9" />
            </svg>
            Summary
          </button>

          <button
            className="btn outline"
            onClick={handleDownloadExcel}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              borderColor: "#16a34a",
              color: "#16a34a",
              fontWeight: 600,
              opacity: selectedUsers.size === 0 ? 0.5 : 1,
            }}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Excel {selectedUsers.size > 0 && `(${selectedUsers.size})`}
          </button>

          {selectedUsers.size > 0 && (
            <div className="status-menu-wrapper" ref={statusMenuRef}>
              <button
                className="btn outline"
                onClick={() => setShowStatusMenu((prev) => !prev)}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  borderColor: "#6366f1",
                  color: "#6366f1",
                  fontWeight: 600,
                }}
              >
                Change Status ({selectedUsers.size})
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </button>

              {showStatusMenu && (
                <div className="status-menu-dropdown">
                  <div
                    className="status-menu-item"
                    onClick={() => openStatusConfirm(true)}
                  >
                    <span
                      className="status-dot"
                      style={{ background: "#16a34a" }}
                    ></span>
                    Activate
                  </div>
                  <div
                    className="status-menu-item"
                    onClick={() => openStatusConfirm(false)}
                  >
                    <span
                      className="status-dot"
                      style={{ background: "#dc2626" }}
                    ></span>
                    Deactivate
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="record-row">
        <span>
          Total: <strong>{sortedData?.length || 0}</strong>
        </span>
        <div
          className="table-controls"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div>
            <label>Sort By First Name:</label>
            <select
              value={nameSort || ""}
              onChange={(e) => {
                setIdSort(null);
                setNameSort(e.target.value || null);
              }}
              className="sort-dropdown"
            >
              <option value="">default</option>
              <option value="asc">A → Z</option>
              <option value="desc">Z → A</option>
            </select>
          </div>
          <div>
            <span className="mx-3"></span>
            <label> Role:</label>
            <select
              value={roleFilter}
              onChange={(e) => setRoleFilter(e.target.value)}
              className="sort-dropdown"
            >
              <option value="all">All</option>
              <option value="student">Student</option>
              <option value="teacher">Teacher</option>
            </select>
          </div>
          <div>
            <span className="mx-3"></span>
            <label> School:</label>
            <select
              value={schoolFilter}
              onChange={(e) => setSchoolFilter(e.target.value)}
              className="sort-dropdown"
            >
              <option value="all">All</option>
              {uniqueSchools.map((school) => (
                <option key={school} value={school}>
                  {school}
                </option>
              ))}
            </select>
          </div>

          <button
            type="button"
            className="adm-reset-btn"
            onClick={handleClearAllFilters}
            disabled={!areAnyFiltersActive}
            title="Reset all filters"
            aria-label="Reset all filters"
          >
            <RotateCcw size={16} />
          </button>
        </div>
      </div>

      <div className="table-container">
        <table
          style={{
            position: "relative",
            zIndex: 1,
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  checked={isAllSelectedOnPage}
                  onChange={handleSelectAll}
                />
              </th>
              <th onClick={toggleIdSort} className="sortable">
                ID {idSort === "asc" ? "↑" : idSort === "desc" ? "↓" : "⇅"}
              </th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Grade</th>
              <th>School</th>

              <th>Role</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {(paginatedUsers || []).map((u, index) => (
              <tr key={u?.user_id}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedUsers.has(u?.user_id)}
                    onChange={() => handleSelectRow(u?.user_id)}
                  />
                </td>

                <td>{u?.user_id || "N/A"}</td>

                <td>{u?.firstname || "N/A"}</td>

                <td>{u?.lastname || "N/A"}</td>

                <td>{u?.email || "NA"}</td>

                <td>
                  {u?.classes
                    ?.map(
                      (c) =>
                        `${c?.grade || "N/A"}${c?.division ? c?.division : ""}`,
                    )
                    .join(", ")}
                </td>

                <td>{u?.school || "N/A"}</td>

                <td>
                  <select
                    value={u?.role_id}
                    onChange={async (e) => {
                      const newRoleId = Number(e.target.value);
                      const previousRoleId = u?.role_id;

                      const payload = {
                        role_id: newRoleId,
                      };

                      const result = await dispatch(
                        changeRole(payload, u?.user_id),
                      );

                      if (result.success) {
                        setUserData((prev) =>
                          prev.map((user) =>
                            user.user_id === u.user_id
                              ? { ...user, role_id: newRoleId }
                              : user,
                          ),
                        );
                        setUserData1((prev) =>
                          prev.map((user) =>
                            user.user_id === u.user_id
                              ? { ...user, role_id: newRoleId }
                              : user,
                          ),
                        );

                        setToastState({
                          show: true,
                          message: "Role updated successfully.",
                          type: "success",
                        });
                      } else {
                        setToastState({
                          show: true,
                          message:
                            result.message ||
                            "Failed to update role. Please try again.",
                          type: "error",
                        });
                      }
                    }}
                    className="role-dropdown"
                  >
                    <option value={1}>Student</option>
                    <option value={2}>Teacher</option>
                  </select>
                </td>

                <td>
                  <span>
                    {u?.status === true ? (
                      <span className="row-active">Active</span>
                    ) : (
                      <span className="row-deactive">Inactive</span>
                    )}
                  </span>
                </td>

                <td
                  className="menu-cell"
                  ref={(el) => (menuRef.current[index] = el)}
                >
                  <span
                    className="menu"
                    onClick={() =>
                      setOpenMenuId(openMenuId === index ? null : index)
                    }
                  >
                    ⋮
                  </span>

                  {openMenuId === index && (
                    <div
                      className="menu-dropdown"
                      ref={(el) => (menuRef.current[index] = el)}
                    >
                      <div
                        className={`menu-item ${
                          u?.status ? "active-item" : ""
                        }`}
                        onClick={(e) => {
                          handleReActivate(e, u);
                          setOpenMenuId(null);
                        }}
                      >
                        active
                      </div>

                      <div
                        className={`menu-item ${
                          !u?.status ? "deactive-item" : ""
                        }`}
                        onClick={(e) => {
                          handleDeActivate(e, u);
                          setOpenMenuId(null);
                        }}
                      >
                        inactive
                      </div>

                      <div
                        className="menu-item"
                        onClick={(e) => {
                          handleEditUser(e, u);
                          setOpenMenuId(null);
                        }}
                      >
                        edit
                      </div>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <div className="page-info">
          Showing {startIndex + 1}–{Math.min(endIndex, sortedData?.length)} of{" "}
          {sortedData?.length}
        </div>
        <div className="page-controls">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(1)}
          >
            |‹
          </button>
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            ‹
          </button>
          <span className="current-page">
            Page {currentPage} of {totalPages}
          </span>
          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            ›
          </button>
          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(totalPages)}
          >
            ›|
          </button>
        </div>
        <div className="page-size">
          Rows:{" "}
          <select
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={30}>30</option>
            <option value={40}>40</option>
            <option value={50}>50</option>
          </select>
        </div>
      </div>

      {showUploadSummary && userData1 && (
        <UploadSummaryModal
          data={userData1}
          onClose={() => setShowUploadSummary(false)}
        />
      )}
       <Loader show={loading} />
      <ToastMessage
        show={toastState.show}
        onClose={() => setToastState({ show: false, message: "", type: "" })}
        message={toastState.message}
        type={toastState.type}
      />
    </div>
  );
}
